<template>
    <div id="app">
        <div class="topNav"
             v-if="!(this.$route.path=='/login' || this.$route.path=='/account_center' || this.$route.path=='/error' || this.$route.path=='/share' || this.$route.path=='/program')">
            <div class="nav">
                <router-link tag="div" :to="{path:'/'}"><i
                        style="margin-right: 25px;">{{getUserInfo.custom_name}}</i><i style="font-size: 12px;">五恒全空气 好宅
                    好空气</i></router-link>

                <div class="row items-center">

                    <div>
                        <el-input placeholder="请输入产品名称" v-model="input" class="input-with-select" size="mini">
                            <el-button slot="append" icon="el-icon-search" @click='routeParams'></el-button>
                        </el-input>
                    </div>
                    <div class="nav_right">
                        <div @click="pushScheme" style="padding-left: 20px;padding-right: 20px;">快速报价</div>
                        <i>|</i>
                        <div @click="customerSolutionHandle" style="padding-left: 20px;padding-right: 20px;">客户方案</div>
                        <i>|</i>
                        <div class="center">
                            <div @click.stop="show=!show">个人中心</div>
                            <transition name="bounce">
                                <transition-group appear tag="ul" name="slider" class="pop" v-if="show">
                                    <router-link tag="li" :key="0" to="/personal_center/my_order"><p>我的订单</p>
                                    </router-link>
                                    <router-link tag="li" :key="1" to="/account_center"><p>账号中心</p></router-link>
                                    <router-link tag="li" :key="2" to="/my_goods_car"><p>购物车 (<i>{{goodsCount}}</i>)</p>
                                    </router-link>
                                    <router-link tag="li" :key="3" to="/custom_list"><p>我的客户</p></router-link>
                                    <!--                                <router-link tag="li" :key="3" to="" @click="pushSchemeList"><p>我的方案</p></router-link>-->
                                    <div tag="li" :key="4"
                                         style="text-align: center;height: 46px;line-height: 46px;margin-right: 20px;margin-left: 20px;">
                                        <p style="border-bottom:1px solid #D0D0D0;">
                                        <span
                                                @click="pushSchemeList"
                                                style="color: #333333;font-size:14px; ">我的方案
                                        </span>
                                        </p></div>
                                    <div tag="li" :key="5"
                                         style="text-align: center;height: 46px;line-height: 46px;margin-right: 20px;margin-left: 20px;">
                                        <p style="border-bottom:1px solid #D0D0D0;">
                                        <span
                                                @click="costAction"
                                                style="color: #333333;font-size:14px; ">成本核算
                                        </span>
                                        </p></div>
                                    <div tag="li" :key="6"
                                         style="text-align: center;height: 46px;line-height: 46px;margin-right: 20px;margin-left: 20px;">
                                        <p style="border-bottom:1px solid #D0D0D0;">
                                        <span
                                                @click="myModelListAction"
                                                style="color: #333333;font-size:14px; ">我的模板
                                        </span>
                                        </p></div>
                                    <div tag="li" :key="7"
                                         style="text-align: center;height: 46px;line-height: 46px;margin-right: 20px;margin-left: 20px;">
                                        <p style="border-bottom:1px solid #D0D0D0;">
                                        <span
                                                @click="modelListAction"
                                                style="color: #333333;font-size:14px; ">模板管理
                                        </span>
                                        </p></div>
                                    <div tag="li" :key="8" style="text-align: center;height: 46px;line-height: 46px;"><p
                                            @click="ExitAccount"><a style="color: #333333;font-size:14px; ">退出登录</a></p>
                                    </div>
                                </transition-group>
                            </transition>
                        </div>
                        <i>|</i>
                        <el-tooltip placement="bottom">
                            <div class="text-body1" slot="content">{{getUserInfo.phone_number}}</div>
                            <div><i class="iconfont icon-icon-test" style="font-size:22px;line-height:22px;">&nbsp;</i>
                            </div>
                        </el-tooltip>
                    </div>
                </div>

            </div>
        </div>
        <router-view></router-view>
        <el-backtop target="#app" :bottom="100">

        </el-backtop>

        <el-dialog
            title="温馨提示"
            :visible.sync="dialogVisible"
            width="30%"
        >
            <span>请至全链条系统,使用最新版本制作在线方案</span>
            <div class="row q-mt-lg">
                <span>链接地址:</span>
                <a href="http://qlt.yuximi.com/#/logon" target="_blank">全链条地址</a>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import src_err from '@/assets/img/err.png'
    import src_banner from '@/assets/img/banner.jpg'
    import {setTimeout} from 'timers';

    export default {
        name: "",
        data() {
            return {
                dialogVisible:false,
                topNav: {},
                search_data: '',
                input: '',
                show: false,
                src: {
                    src_err,
                    src_banner
                },
            }
        },
        computed: {
            // TODO 上线要改
            goodsCount() {
                return this.$store.getters.get_goodsCount
            },
            getUserInfo() {

                return this.$store.getters.get_userInfo
            }
        },
        methods: {
            // 客户方案
            customerSolutionHandle() {
                this.$router.push({name: "customer_solution"})
            },
            //退出账号
            ExitAccount() {
                this.$confirm('确认退出当前账号?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        url: 'signOut',
                        data: {}
                    }).then((res) => {
                        if (res.code == 1) {
                            this.$message({
                                message: `${res.msg}`,
                                type: 'success'
                            });
                            this.$store.commit({
                                type: 'set_userInfo',
                                data: {}
                            })
                            this.$router.push("/login")
                        }
                    }).catch((err) => {
                        console.log(err)
                    })
                }).catch(() => {

                });
            },
            pushScheme() {

                this.dialogVisible=true

                // var url = 'http://vip.stdq.com/scheme/#/?' + 'token=' + this.getUserInfo.utoken + '&' + 'company=' + this.getUserInfo.usercompany
                // window.open(url, '_blank');
            },
            pushSchemeList() {
                var url = 'http://vip.stdq.com/scheme/#/program/?' + 'token=' + this.getUserInfo.utoken + '&' + 'company=' + this.getUserInfo.usercompany
                window.open(url, '_blank');
            },
            costAction() {
                var url = 'http://vip.stdq.com/scheme/#/cost/?' + 'token=' + this.getUserInfo.utoken + '&' + 'company=' + this.getUserInfo.usercompany
                window.open(url, '_blank');
            },
            myModelListAction() {
                var url = 'http://vip.stdq.com/scheme/#/myModel/?' + 'token=' + this.getUserInfo.utoken + '&' + 'company=' + this.getUserInfo.usercompany
                window.open(url, '_blank');
            },
            modelListAction() {
                var url = 'http://vip.stdq.com/scheme/#/model/?' + 'token=' + this.getUserInfo.utoken + '&' + 'company=' + this.getUserInfo.usercompany
                window.open(url, '_blank');
            },
            tapAction() {
                let target = this.$refs.target
                target.setAttribute('href', window.location.origin + '/#/account_center')
            },
            mykeydown(event) {
                let e = event || window.event
                if (e.keyCode === 13) {
                    setTimeout(() => {
                        this.routeParams()
                    }, 300)
                }
            },
            routeParams() {
                if (this.input.length > 0) {
                    if (this.$route.path == '/product_list') {
                        if (this.input == this.search_data) {
                            this.$message({
                                message: '连续两次搜索不能为同一内容',
                                type: 'warning',

                            });
                        } else {
                            this.search_data = this.input
                        }
                    } else {
                        this.$router.push({
                            path: '/product_list',
                            query: {
                                product_name: this.input
                            }
                        })
                    }
                } else {
                    this.$message({
                        message: `搜索内容不能为空`,
                        type: 'warning',
                    });
                }
            },
            crear_search_data() {
                this.input = ''
            },
        },
        mounted() {
            window.addEventListener('click', (event) => {
                let eve = event || window.event
                eve.stopPropagation()
                this.show = false
            })
        },
        beforeDestroy() {
            window.removeEventListener('click', () => {
            })
        }
    };
</script>

<style lang="scss">
    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        position: relative;
        height: 100%;
        /*min-width: 1100px;*/
        overflow-y: auto;

        .topNav {
            width: 100%;
            /*height: 110px;*/
            height: 46px;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 2;
            background-color: red;
        }

        .router {
            min-height: 100%;
        }

        .route {
            box-sizing: border-box;
            padding-top: 46px;
            min-height: 100%;
        }
    }

    .nav {
        display: -webkit-flex;
        -webkit-align-items: center;
        -webkit-justify-content: space-between;
        color: white;
        box-sizing: border-box;
        background: #333333;
        margin: 0 auto;
        padding: 0 0px 0 60px;
        height: 46px;

        > div:first-child {
            cursor: pointer;
        }

        > div:first-child:hover {
            color: #409eff;
        }

        .nav_right {
            display: flex;
            align-items: flex-end;

            > div {
                cursor: pointer;
                margin: 0 20px;
                display: flex;
                align-items: flex-end;
            }

            > div:hover {
                color: #409eff;
            }

            /*>div:last-child{*/
            /*    margin-right:0;*/
            /*    background-color: red;*/
            /*    >ul{*/
            /*        position:absolute;*/
            /*        right:6px;*/
            /*        top:45px;*/
            /*        background:#FFFFFF;*/
            /*        width:170px;*/
            /*        border:1px solid #D0D0D0;*/
            /*        z-index:3800;*/
            /*        >li{*/
            /*            color:#333;*/
            /*            font-size:14px;*/
            /*            cursor:pointer;*/
            /*            padding:0 20px;*/
            /*            text-align:center;*/
            /*            >p{*/
            /*                border-bottom:1px solid #D0D0D0;*/
            /*                line-height:45px;*/
            /*            }*/
            /*            >p:hover{*/
            /*                transform: scale(1.15);*/
            /*                transition:all .3s;*/
            /*            }*/

            /*        }*/
            /*        >li:hover{*/
            /*            background:#ececec;*/
            /*            color:#4285f4;*/
            /*            >p:last-child{*/
            /*                border-bottom:none;*/
            /*            }*/
            /*        }*/
            /*    }*/
            /*}*/
        }
    }

    .center {
        margin-right: 0;

        > ul {
            position: absolute;
            right: 40px;
            top: 45px;
            background: #FFFFFF;
            width: 170px;
            border: 1px solid #D0D0D0;
            z-index: 3800;

            > li {
                color: #333;
                font-size: 14px;
                cursor: pointer;
                padding: 0 20px;
                text-align: center;

                > p {
                    border-bottom: 1px solid #D0D0D0;
                    line-height: 45px;
                }

                > p:hover {
                    transform: scale(1.15);
                    transition: all .3s;
                }

            }

            > li:hover {
                background: #ececec;
                color: #4285f4;

                > p:last-child {
                    border-bottom: none;
                }
            }
        }
    }

    .bounce-enter-active {
        animation: bounce-in .5s;
    }

    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }

    @keyframes bounce-in {
        0% {
            transform: translateY(0px);
            height: 0px;
        }
        50% {
            transform: translateY(20px);
            height: 410px;
        }
        100% {
            transform: translateY(0px);
            height: 405px;
        }
    }

    .slider-enter, .slider-leave-to {
        transition: all .5s linear;
        line-height: 16px;
        opacity: 0;
    }

    .slider-enter-active, .slider-leave-active {
        transition: all .5s linear;
        line-height: 60px;
        opacity: .5;
    }

    .slider-enter-to, .slider-leave {
        transition: all .5s linear;
        line-height: 45px;
        opacity: 1;
    }
</style>
<style lang="scss" scoped>
    .publicTitle {
        background: #f1f1f1;
        width: 100%;
    }

    .title_box {
        display: -webkit-flex;
        -webkit-align-items: center;
        -webkit-justify-content: space-between;
        width: 1200px;
        height: 64px;
        margin: 0 auto;
        color: #101010;

        .title {
            display: -webkit-flex;
            -webkit-align-items: flex-end;

            h3 {
                font-weight: 600;
                font-size: 36px;
                line-height: 36px;
                margin-right: 25px;
            }
        }

        .search {
            display: flex;
            align-items: center;
            background: white;
            position: relative;
            width: 290px;
            padding: 0 35px 0 15px;
            border: 1px solid #dddddd;
            border-radius: 8px;

            input {
                display: block;
                padding: 0;
                width: 240px;
                height: 34px;
                border: none;
                outline: none;
                box-shadow: none;
            }

            i {
                width: 30px;
                height: 30px;
                margin-left: 10px;
                cursor: pointer;
                text-align: center;
                line-height: 30px;
                font-size: 20px;
                color: #888;
                position: absolute;
                top: 2px;
                right: 4px;
            }

            i:hover {
                color: #409eff;
            }
        }

        .search:hover {
            border: 1px solid #409eff;
        }
    }

</style>
